export default __webpack_public_path__ + "static/media/ic_check_circle.d5ebdd1c.svg";